export const dashboard = {
  charts: {
    cta: {
      createInvoice: 'Factuur aanmaken',
      text: 'Zodra je eerste factuur is aangemaakt, kan je hier je statistieken zien.',
      title: 'Je eerste factuur aanmaken',
    },
    labels: {
      copyright: 'Auteursvergoeding',
      currentQ: 'Lopend kwartaal (K{{ quarter }})',
      expired: 'Vervallen',
      notExpired: 'Niet vervallen',
      performance: 'Beroepsinkomsten',
      previousQ: 'Vorige kwartalen',
    },
    overview: 'Overzicht',
    overviewChart: 'Grafiek met overzicht facturen per status',
    summary: {
      amountInvoices: 'Aantal facturen',
      total: 'Totaal',
      value: 'Bedrag',
    },
    totalBilled: 'Totaal gefactureerd',
    totalBilledChart: 'Grafiek met een overzicht van je facturen',
    yearSelector: 'Jaar – {{title}}',
  },
  error: {
    title: 'Fout bij het laden van je dashboard.',
  },
  forumPostsSummary: {
    error: 'Posts niet gevonden',
    link: 'Naar het forum',
    title: 'Nieuwste posts',
  },
  frameworkAgreement: {
    alreadySigned: 'Je bent al akkoord gegaan met de raamovereenkomst.',
    checkboxError: 'Om aan de slag te gaan, moet je akkoord gaan met de raamovereenkomst.',
    checkboxLabel: 'Ik ga akkoord met de raamovereenkomst.',
    subtitle: 'Geen kleine of verborgen lettertjes, alleen maar duidelijke afspraken.',
    title: 'Lees de raamovereenkomst',
  },
  header: {
    actionBlock: {
      button: 'Factuur aanmaken',
      dropdown: {
        client: 'Klant aanmaken',
        creditnote: 'Creditnota aanmaken',
        quotation: 'Offerte aanmaken',
      },
    },
  },
  jobPostsSummary: {
    error: 'Opdrachten niet gevonden',
    link: 'Naar de opdrachten',
    title: 'Nieuwste opdrachten',
  },
  outstandingInvoices: {
    expired: '{{amount}} vervallen',
    summary_one: '{{count}} factuur',
    summary_other: '{{count}} facturen',
    summaryWithExpired_one: '{{count}} factuur, waarvan {{expiredCount}} vervallen',
    summaryWithExpired_other: '{{count}} facturen, waarvan {{expiredCount}} vervallen',
    table: {
      amount: 'Bedrag',
      dueDate: 'Vervaldatum',
      invoice: 'Factuur',
    },
    title: 'Openstaande facturen',
    toReceive: 'Nog te ontvangen',
    viewAll: 'Bekijk alle openstaande facturen',
  },
  progression: {
    progress: '{{completedSteps}} van de {{totalSteps}} voltooid',
    steps: {
      completed: 'Voltooid:',
      create: 'Maak en activeer je account',
      createInvoice: {
        text: 'Voltooi eerst de andere stappen',
        title: 'Maak en verstuur je eerste factuur',
      },
      iban: 'Vul je rekeningnummer in',
      peppol: 'Registreer je Peppol-inbox',
      signAddendum2024: 'Teken het addendum aan je raamovereenkomst met Creative Shelter',
      signContract: 'Teken je raamovereenkomst',
      signContractModalTitle: 'Teken je Creative Shelter-raamovereenkomst',
      uncompleted: 'Nog te doen:',
      vatRegulation: 'Duid je btw-statuut aan',
    },
    subtitle_one: 'Nog {{count}} stap voor je je eerste factuur kan versturen.',
    subtitle_other: 'Nog {{count}} stappen voor je je eerste factuur kan versturen.',
    subtitle_zero: 'Je bent klaar om je eerste factuur te versturen!',
    title: 'Vervolledig je account',
  },
  stats: {
    copyrightAverage: {
      label: 'Gemiddelde auteursrechten',
      tooltip:
        'Vierjaarlijks gemiddelde dat je ontving als auteursvergoeding, via Creative Shelter.<br>Waarom dit belangrijk is en hoe dit berekend wordt, <a href="https://knowledge.creativeshelter.be/hoe-wordt-jouw-gemiddelde-auteursrechten-berekend-op-het-dashboard" target="_blank">lees je hier</a>.',
    },
    copyrightThisYear: {
      label: 'Totale auteursvergoeding in {{year}}',
      tooltip:
        'Totaalbedrag auteursvergoeding van al je betaalde facturen dit jaar. <br>Alles over de jaarlijkse limiet van je auteursvergoeding lees je <a href="https://www.creativeshelter.be/begroting-hervorming-van-auteursrecht/" target="_blank">hier</a>.',
    },
    error: {
      title: 'Fout bij het laden van je dashboard.',
    },
    invoicedSumThisYear: {
      label: 'Totale inkomsten in {{year}}',
      tooltip: 'Totaalbedrag dat je dit jaar al factureerde via ons platform.',
    },
    title: 'Statistieken',
  },
};
